import * as r from 'ramda';

export default (name) => {
  var obj = {
    waiters: [],
    run: false
  };

  obj.ok = (timeout = 0) => {
    if (obj.run) {
      return Promise.resolve(obj.value);
    } else {
      return new Promise((resolve, reject) => {
        const timer = timeout ? setTimeout(() => {
          obj.waiters = r.without([fn], obj.waiters)
          reject(new Error("Waiting for stoplight: " + name))
        }, timeout) : null;
        const fn = (value) => {
          clearTimeout(timer);
          resolve(value);
        }
        obj.waiters.push(fn);
      })
    }
  }

  obj.go = (value) => {
    const waiters = obj.waiters;
    obj.run = true;
    obj.value = value;
    obj.waiters = [];
    waiters.forEach(fn => fn(value))
  }

  obj.stop = () => {
    obj.run = false;
  }

  return obj;
}


// WEBPACK FOOTER //
// ./src/api/stoplight.js